import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "wellness-center"

export const Add = async (values) => {
    return await axiosInstance(options).post(`${path}/coach/add`, values);
}
export const List = async (values) => {
    return await axiosInstance(options).post(`${path}/coach/list`, values);
}

export const Details = async (id) => {
    return await axiosInstance(options).get(`${path}/coach/details?o_id=${id}`);
}

export const Edit = async (values, role) => {
    return await axiosInstance(role ? { role } : options).put(`${path}/coach/edit`, values);
}